(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  // The footer wordmark: arm it below the line, then let it rise once it is a third in view.
  if (!customElements.get('footer-mark')) {
    customElements.define(
      'footer-mark',
      class extends HTMLElement {
        connectedCallback() {
          const show = () => this.classList.add('is-in-view');
          const still = document.documentElement.dataset.motion === 'false' || matchMedia('(prefers-reduced-motion: reduce)').matches;
          if (still || !('IntersectionObserver' in window)) return show();
          this.setAttribute('data-armed', '');
          this.io = new IntersectionObserver(
            (entries) => {
              if (!entries.some((entry) => entry.isIntersecting)) return;
              this.io.disconnect();
              // Hidden below the clip, the lazy image never starts loading by itself: start it, then wait for it so
              // the rise never plays on an empty box.
              const img = this.querySelector('img');
              if (img) img.loading = 'eager';
              Promise.resolve(img && img.decode ? img.decode() : null).catch(() => {}).then(show);
            },
            { threshold: 0.3 }
          );
          this.io.observe(this);
        }

        disconnectedCallback() {
          if (this.io) this.io.disconnect();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
  (function () {
    function fallbackCopy(text) {
      var area = document.createElement('textarea');
      area.value = text;
      area.setAttribute('readonly', '');
      area.style.position = 'fixed';
      area.style.opacity = '0';
      document.body.appendChild(area);
      area.select();
      var ok = false;
      try {
        ok = document.execCommand('copy');
      } catch (e) {
        ok = false;
      }
      area.remove();
      return ok ? Promise.resolve() : Promise.reject(new Error('copy failed'));
    }

    document.addEventListener('click', function (event) {
      var button = event.target.closest && event.target.closest('[data-copy-link]');
      if (!button) return;
      var text = button.getAttribute('data-copy-link');
      var copy =
        navigator.clipboard && window.isSecureContext
          ? navigator.clipboard.writeText(text).catch(function () {
              return fallbackCopy(text);
            })
          : fallbackCopy(text);
      copy
        .then(function () {
          var label = button.querySelector('[data-copy-label]');
          var status = button.closest('aside') && button.closest('aside').querySelector('[data-copy-status]');
          var original = label ? label.textContent : '';
          var done = button.getAttribute('data-copied');
          if (label) label.textContent = done;
          if (status) status.textContent = done;
          button.setAttribute('data-done', '');
          setTimeout(function () {
            if (label) label.textContent = original;
            if (status) status.textContent = '';
            button.removeAttribute('data-done');
          }, 2200);
        })
        .catch(function () {
          window.prompt('', text);
        });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wishlist"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('lumi-wishlist')) return;

    var KEY = 'lumi:wishlist';

    class LumiWishlist extends HTMLElement {
      connectedCallback() {
        this.grid = this.querySelector('[data-wishlist-grid]');
        this.clearButton = this.querySelector('[data-wishlist-clear]');
        this.countEl = this.querySelector('[data-wishlist-count]');
        this.onChange = this.onChange.bind(this);
        document.addEventListener('lumi:wishlist:changed', this.onChange);
        if (this.clearButton) {
          this.clearButton.addEventListener('click', function () {
            if (window.Lumi && window.Lumi.wishlist) window.Lumi.wishlist.clear();
          });
        }
        // Deferred scripts (lumi.js, wishlist.js) have all run by DOMContentLoaded.
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', this.render.bind(this), { once: true });
        } else {
          this.render();
        }
      }

      disconnectedCallback() {
        document.removeEventListener('lumi:wishlist:changed', this.onChange);
      }

      handles() {
        var Lumi = window.Lumi || {};
        var list = [];
        if (Lumi.wishlist && Lumi.wishlist.get) list = Lumi.wishlist.get();
        else if (Lumi.storage) list = Lumi.storage.get(KEY, []);
        else {
          try {
            list = JSON.parse(window.localStorage.getItem(KEY) || '[]');
          } catch (e) {
            list = [];
          }
        }
        return Array.isArray(list) ? list.filter(function (h) { return typeof h === 'string' && h; }) : [];
      }

      productUrl(handle) {
        var root = (window.Lumi && window.Lumi.routes && window.Lumi.routes.root) || '/';
        return root.replace(/\/$/, '') + '/products/' + encodeURIComponent(handle);
      }

      async fetchCard(handle) {
        try {
          var url = this.productUrl(handle);
          var html;
          if (window.Lumi && window.Lumi.fetchSection) {
            html = await window.Lumi.fetchSection(url, 'product-card-render');
          } else {
            var res = await fetch(url + '?section_id=product-card-render');
            if (!res.ok) return null;
            html = await res.text();
          }
          var doc = new DOMParser().parseFromString(html, 'text/html');
          return doc.querySelector('.product-card');
        } catch (e) {
          return null;
        }
      }

      async render() {
        var handles = this.handles();
        if (!handles.length) return this.setState('empty');
        this.setState('loading');
        var cards = await Promise.all(handles.map(this.fetchCard.bind(this)));
        var live = this.handles();
        var fragment = document.createDocumentFragment();
        cards.forEach(function (card, i) {
          if (card && live.indexOf(handles[i]) !== -1) fragment.appendChild(document.importNode(card, true));
        });
        this.grid.replaceChildren(fragment);
        var Lumi = window.Lumi || {};
        if (Lumi.wishlist && Lumi.wishlist.sync) Lumi.wishlist.sync(this.grid);
        this.update();
      }

      onChange(event) {
        var handles = (event.detail && event.detail.handles) || this.handles();
        var cards = this.grid.querySelectorAll('.product-card');
        var shown = Array.prototype.map.call(cards, function (card) {
          return card.getAttribute('data-product-handle');
        });
        var added = handles.some(function (h) {
          return shown.indexOf(h) === -1;
        });
        if (added) return this.render();
        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var self = this;
        cards.forEach(function (card) {
          if (handles.indexOf(card.getAttribute('data-product-handle')) !== -1) return;
          if (reduce || !card.animate) {
            card.remove();
            return;
          }
          card.style.pointerEvents = 'none';
          card
            .animate([{ opacity: 1, transform: 'none' }, { opacity: 0, transform: 'scale(0.96)' }], {
              duration: 260,
              easing: 'cubic-bezier(.2,.7,.1,1)',
            })
            .finished.then(function () {
              card.remove();
              self.update();
            });
        });
        this.update();
      }

      update() {
        var count = this.grid.querySelectorAll('.product-card').length;
        if (this.clearButton) this.clearButton.hidden = count === 0 || !(window.Lumi && window.Lumi.wishlist);
        if (this.countEl) {
          var template = count === 1 ? this.grid.dataset.countOne : this.grid.dataset.countOther;
          this.countEl.textContent = count ? template.replace('[n]', count) : '';
        }
        this.setState(count ? 'ready' : 'empty');
      }

      setState(state) {
        this.dataset.state = state;
      }
    }

    customElements.define('lumi-wishlist', LumiWishlist);
  })();

  } catch(e) { console.error(e); }
})();
})();
